import { type DomId, ads } from "@/vendors/GoogleTag/config/ad-slots.config"

/**
 * Defines a Google Ad slot with the specified configuration.
 *
 * This function creates a Google Publisher Tag (GPT) ad slot by combining the ad unit path
 * with the ad unit code from the ads configuration. It sets up size mappings for responsive
 * ads and registers the slot with Google's publisher ad service.
 *
 * @param domId - The DOM element ID where the ad will be rendered
 * @param adUnitPath - The Google Ad Manager ad unit path
 *
 * @see {@link https://developers.google.com/publisher-tag/reference GPT Reference Documentation}
 */
export function defineGoogleAdSlot(domId: DomId, adUnitPath: string) {
  const { adUnitCode, mapping, sizes } = ads[domId]

  const adMapping = googletag.sizeMapping()

  for (const breakpoint of Object.keys(mapping)) {
    const breakpointSize = Number(breakpoint)
    adMapping.addSize([breakpointSize, 0], mapping[breakpointSize])
  }

  const builtMapping = adMapping.build()

  const slot = googletag.defineSlot(`${adUnitPath}${adUnitCode}`, sizes, domId)

  if (slot && builtMapping !== null) {
    slot.defineSizeMapping(builtMapping).addService(googletag.pubads())
  }
}
